import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { getAllVideos } from '../services/api';
import { AudioContext } from '../App';
import Partenaires from '../components/Partenaires';
import AboutSection from '../components/AboutSection';
import Programme from '../components/Programme'; 

const Home = () => {
  const { isPlaying, togglePlay, pauseAudio, activeVideoId, setActiveVideoId } = useContext(AudioContext);
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const res = await getAllVideos();
        const sorted = res.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setVideos(sorted);
      } catch (err) {
        console.error("Erreur chargement accueil", err);
      }
    };
    fetchHomeData();
  }, []);

  const handlePlayVideo = (id) => {
    pauseAudio();
    setActiveVideoId(id);
  };

  const getYouTubeEmbedUrl = (url) => {
    if (!url) return '';
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    const videoId = (match && match[7].length === 11) ? match[7] : null;
    return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0` : url;
  };

  const getThumb = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length === 11) 
      ? `https://img.youtube.com/vi/${match[7]}/hqdefault.jpg` 
      : 'https://via.placeholder.com/480x270?text=Fréquence+974';
  };

  return (
    <div className="bg-light min-vh-100">
      {/* HERO SECTION */}
      <div className="hero-section position-relative overflow-hidden">
        <div className="hero-overlay"></div>
        <div className="container position-relative z-1 py-4">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8 text-white">
              
              {/* REMPLACEMENT DU BADGE PAR LE BOUTON DE LECTURE DYNAMIQUE */}
              {!isPlaying && (
                <div className="mb-3">
                  <button 
                    onClick={togglePlay}
                    className="btn btn-warning rounded-pill px-4 py-2 fw-black text-uppercase shadow-lg pulse-button border-white border-opacity-25"
                    style={{ fontSize: '0.9rem' }}
                  >
                    <i className="bi bi-play-fill fs-5 me-1"></i>
                    Lancer la lecture
                  </button>
                </div>
              )}

              <h1 className="h2 fw-black text-uppercase mb-2 italic">
                L'intensité de <span className="text-warning">l'Océan Indien</span>
              </h1>
              <p className="small fw-bold opacity-75 mb-3 mx-auto" style={{maxWidth: '500px'}}>
                Retrouvez vos animateurs, les hits et l'actu de La Réunion en live.
              </p>
              <div className="d-flex gap-2 justify-content-center">
                <a href="#replays" className="btn btn-primary btn-sm rounded-pill px-4 fw-black text-uppercase shadow-sm">
                  Nos Replays
                </a>
                <a href="#grille" className="btn btn-outline-light btn-sm rounded-pill px-4 fw-black text-uppercase">
                  Programmes
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SECTION PRÉSENTATION & RÉSEAUX */}
      <AboutSection />

      {/* MAIN CONTENT (REPLAYS) */}
      <main className="container pb-5 mt-5" id="replays">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
              <h4 className="fw-black text-uppercase m-0">
                <i className="bi bi-play-circle-fill text-danger me-2"></i>Derniers Replays
              </h4>
              <Link to="/pagevideo" className="btn btn-outline-primary btn-sm rounded-pill fw-bold text-uppercase px-3" style={{fontSize: '11px'}}>
                Voir tout →
              </Link>
            </div>
            
            <div className="row g-4">
              {videos.slice(0, 4).map(v => (
                <div key={v.id} className="col-md-6">
                  <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden video-card bg-white">
                    <div className="position-relative aspect-video bg-dark">
                      {activeVideoId === v.id ? (
                        <iframe
                          src={getYouTubeEmbedUrl(v.url_video)}
                          title={v.title}
                          className="w-100 h-100 border-0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      ) : (
                        <div 
                          className="w-100 h-100 video-thumbnail-container" 
                          style={{ cursor: 'pointer' }}
                          onClick={() => handlePlayVideo(v.id)}
                        >
                          <img src={getThumb(v.url_video)} className="w-100 h-100 object-fit-cover opacity-75" alt={v.title} />
                          <div className="position-absolute top-50 start-50 translate-middle play-icon-overlay">
                            <i className="bi bi-play-fill text-white display-2 opacity-75"></i>
                          </div>
                          <span className="position-absolute top-0 start-0 m-2 badge bg-danger text-uppercase" style={{fontSize: '10px'}}>{v.category || "Replay"}</span>
                        </div>
                      )}
                    </div>
                    <div className="card-body p-3 text-center">
                      <h6 className="fw-black text-dark mb-1 text-uppercase">{v.title}</h6>
                      <small className="text-muted fw-bold" style={{fontSize: '11px'}}>
                        {new Date(v.created_at || Date.now()).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
                      </small>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-5">
              <Link to="/pagevideo" className="btn btn-dark btn-md rounded-pill px-5 fw-black text-uppercase shadow-lg border-0 bg-gradient" style={{ fontSize: '13px', letterSpacing: '1px' }}>
                Accéder à la vidéothèque <i className="bi bi-arrow-right-circle ms-2"></i>
              </Link>
            </div>
          </div>
        </div>
        
        {/* SECTION PROGRAMME RADIO */}
        <div className="container mt-2" id="grille">
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <Programme />
            </div>
          </div>
        </div>

        <div className="row justify-content-center mt-5">
          <div className="col-lg-11">
            <Partenaires />
          </div>
        </div>
      </main>

      <style>{`
        .fw-black { font-weight: 900; }
        .italic { font-style: italic; }
        .hero-section {
            background: url('https://images.unsplash.com/photo-1571330735066-03aaa9429d89?auto=format&fit=crop&q=80&w=2000');
            background-size: cover;
            background-position: center 30%;
            border-bottom: 4px solid #ffc107;
        }
        .hero-overlay {
            position: absolute;
            top: 0; left: 0; width: 100%; height: 100%;
            background: linear-gradient(135deg, rgba(0,45,91,0.92) 0%, rgba(0,74,153,0.85) 100%);
        }
        .z-1 { z-index: 1; }
        .aspect-video { aspect-ratio: 16 / 9; }
        .play-icon-overlay {
            transition: all 0.3s ease;
            transform: translate(-50%, -50%) scale(0.8);
            opacity: 0;
        }
        .video-thumbnail-container:hover .play-icon-overlay {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
        }
        .video-card { transition: transform 0.3s ease; }
        .video-card:hover { transform: translateY(-5px); }
        
        .pulse-button {
          animation: button-glow 2s infinite;
        }

        @keyframes button-glow {
          0% { box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.7); }
          70% { box-shadow: 0 0 0 15px rgba(255, 193, 7, 0); }
          100% { box-shadow: 0 0 0 0 rgba(255, 193, 7, 0); }
        }
      `}</style>
    </div>
  );
};

export default Home;